import * as React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

import './CloseHomeButton.scss';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';

export interface CloseHomeButtonProps {
  queryState: GlobalPrivateState['queryState'];
}

class CloseHomeButtonPartial extends React.Component<CloseHomeButtonProps> {
  public render() {
    const folderId = this.props.queryState.params.folderId;

    return (
      <div className="close-home-button-partial">
        <Link to={folderId ? `/folders/${folderId}` : "/"} className="close-btn">
          <FontAwesomeIcon icon={faTimes} />
        </Link>
      </div>
    );
  }
}


export const CloseHomeButton = connect((state: GlobalPrivateState) => ({
  queryState: state.queryState,
}))(CloseHomeButtonPartial);

export default CloseHomeButton;